export enum UserPreferences {
  PLANNING = 'PLANNING',
  noShowAgainScreenerPlanningModal = 'noShowAgainScreenerPlanningModal',
}
